import $ from "jquery";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import {
    currentPageIsMainRoom,
    getCurrentPageId,
} from "@bd-stores/user-progress";
import bdjs from "@bd-core/bdjs";
import GameLogic from "@bd-core/game-logic";
import { getState } from "@bd-stores/store";

export default class CompletionPopup {
    constructor() {
        this.elms = {
            popup: ".js-room-completion",
            continueBtn: ".js-completionPopup-continue",
            reward: ".completionPopup__reward",
            ladderTitle: ".completionPopup__reward-label",
            ladderLabel: ".completionPopup__reward-type",
            ladderName: ".completionPopup__reward-name",
            ladderImage: ".completionPopup__reward-icon img",
        };

        this.nextRoomID = null;

        return this;
    }

    init() {
        const elms = this.elms;
        const $popup = $(elms.popup);

        $popup.find(elms.continueBtn).on("click", () => {
            if ($(elms.continueBtn).hasClass("is-final")) {
                GameLogic.goToPage(
                    CONFIG.game.rooms.find((room) => room.type === "main-room")
                        .id,
                );
            } else {
                GameLogic.goToPage(this.nextRoomID);
            }
        });

        return this;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];
        states.completions.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.completions && states.completions.includes(roomId);
    }

    maybeResetState(roomId) {
        if (!this._getHasSeen(roomId)) return false;

        let states = Storage.get("states", {});
        if (!states?.completions) states.completions = [];

        const initialLength = states.completions.length;
        const completions = bdjs.removeItemArray(states.completions, roomId);

        //There is item removed, we need to update the Storage
        if (completions.length !== initialLength) {
            states.completions = completions;
            return Storage.set("states", states);
        }

        return false;
    }

    show(roomId, isMiddleState, roomAnswers) {
        // display completion popup only in current challenge room and main room
        const showThisInRoom = ["main-room", roomId];
        const currentPageId = getCurrentPageId();
        const isCurrentPageMainroom = currentPageIsMainRoom();
        const hasSeen = this._getHasSeen(roomId);

        if (hasSeen && !showThisInRoom.includes(currentPageId)) return;

        if (hasSeen && isCurrentPageMainroom) return;

        const rooms = CONFIG?.game?.rooms || false;

        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        if (!room) return;
        let $popup = $(this.elms.popup);
        let title = room?.room?.completion_popup?.title || false;
        let text = room?.room?.completion_popup?.content || false;
        let ladderTitle = room?.room?.completion_popup?.ladder_title || false;
        let ladderLabel = room?.room?.completion_popup?.ladder_label || false;
        let ladderName = room?.room?.completion_popup?.ladder_name || false;
        let continueBtnText =
            room?.room?.completion_popup?.continue_btn_text || false;
        let ladderImage = room?.room?.completion_popup?.ladder_image || false;

        if (isMiddleState) {
            let middleStateCounter = 0;

            if (typeof roomAnswers == "object") {
                $.each(roomAnswers, (answerId, objAnswer) => {
                    if (objAnswer?.isMiddleState) middleStateCounter++;
                });
            }

            text = room?.room?.completion_popup?.middlecontent || "";
            text = text.replaceAll("{x}", `${middleStateCounter}`);
        }

        if (isCurrentPageMainroom) {
            $(this.elms.goToMainRoom).addClass("is-mainroom");
        } else {
            $(this.elms.goToMainRoom).removeClass("is-mainroom");
        }

        if (!title && !text) return;

        if ($popup.hasClass("is-open")) this.hide();

        $popup.find(".completionPopup__title").text(title);
        if (text) $popup.find(".completionPopup__content ").html(text);
        if (ladderName && ladderImage) {
            $popup.find(this.elms.reward).show();
            $popup.find(this.elms.ladderTitle).text(ladderTitle);
            $popup.find(this.elms.ladderLabel).text(ladderLabel);
            $popup.find(this.elms.ladderName).text(ladderName);
            $popup.find(this.elms.ladderImage).attr("src", ladderImage);
            $popup
                .find(this.elms.continueBtn)
                .find("span")
                .first()
                .text(continueBtnText);
        } else {
            $popup.find(this.elms.reward).hide();
        }

        $popup.addClass("is-open");

        if (!hasSeen) this._setHasSeen(roomId);
    }

    hide() {
        const $popup = $(this.elms.popup);
        $popup.removeClass("is-open");
    }

    _checkRoomStatuses(roomId) {
        const gameProgress = getState().gameProgress;
        const roomStatuses = gameProgress.roomStatus;
        let isAllRoomCompleted = true;

        const rooms = CONFIG.game.rooms.filter(
            (room) => room.type !== "main-room" && room.type !== "ladder-room",
        );
        const totalRooms = rooms.length;
        const completedRooms = Object.values(roomStatuses).filter(
            (status) => status === "is-status-completed",
        ).length;
        isAllRoomCompleted = completedRooms === totalRooms;

        const $continueBtn = $(this.elms.popup).find(this.elms.continueBtn);
        $continueBtn.toggleClass("is-final", isAllRoomCompleted);

        if (isAllRoomCompleted) {
            $continueBtn.show();
        } else {
            const currentRoomIndex = rooms.findIndex(room => room.id === roomId);

            for (let i = 0; i < rooms.length; i++) {
                const checkIndex = (currentRoomIndex + 1 + i) % rooms.length;
                const nextRoom = rooms[checkIndex];
                const nextRoomStatus = roomStatuses[nextRoom.id];
                if (nextRoomStatus !== "is-status-completed") {
                    this.nextRoomID = nextRoom.id;
                    break;
                }
            }
        }
    }
}
